import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import Field from '../constants/Field';
import { IApiaField } from '../types';

export interface IImageField extends IApiaField {
  getValue(): null;
  setValue(): null;
  getLabel(): void;
  clearValue(): null;
}

export default class ImageField extends ApiaField implements IImageField {
  constructor(field: HTMLImageElement, form: ApiaForm) {
    super(field, form, [Field.PROPERTY_VISIBILITY_HIDDEN]);
  }

  clearValue(): null {
    if (this.checkFieldExistsInDocument(this.fldId)) {
      throw new Error(
        `Apia JSApi Error: The Field ${
          this.fldType as string
        } does not support this function`,
      );
    }
    return null;
  }

  getLabel(): void {
    throw new Error(
      `Apia JSApi Error: The field ${
        this.fldType as string
      } does not use a label`,
    );
  }

  getValue(): null {
    if (this.checkFieldExistsInDocument(this.fldId)) {
      throw new Error(
        `Apia JSApi Error: The Field ${
          this.fldType as string
        } does not support this function`,
      );
    }
    return null;
  }

  setValue(): null {
    if (this.checkFieldExistsInDocument(this.fldId)) {
      throw new Error(
        `Apia JSApi Error: The Field ${
          this.fldType as string
        } does not support this function`,
      );
    }
    return null;
  }
}
